import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import { Grid, Icon, Modal, Button, Segment } from 'semantic-ui-react';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

// Fix for default marker icon
let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41]
});
L.Marker.prototype.options.icon = DefaultIcon;

interface Props {
    latitude: number;
    longitude: number;
}

export const GameLocationPreview: React.FC<Props> = ({ latitude, longitude }) => {
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const position: [number, number] = [latitude, longitude];

    // Small preview map
    const PreviewMap = () => (
        <MapContainer 
            center={position} 
            zoom={13} 
            style={{ height: '150px', width: '100%', borderRadius: '4px', cursor: 'pointer' }}
            zoomControl={false}
            dragging={false}
            touchZoom={false}
            scrollWheelZoom={false}
            doubleClickZoom={false}
        >
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution={t('gameLocationPreview.mapAttribution')}
            />
            <Marker position={position} />
        </MapContainer>
    );

    // Full screen map for modal
    const FullScreenMap = () => (
        <MapContainer 
            center={position} 
            zoom={14} 
            style={{ height: '70vh', width: '100%', borderRadius: '8px' }}
        >
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution={t('gameLocationPreview.mapAttribution')}
            />
            <Marker position={position} />
        </MapContainer>
    );

    return (
        <Segment attached>
            <Grid verticalAlign='middle'>
                <Grid.Column width={1}>
                    <Icon name='marker' size='large' color='teal'/>
                </Grid.Column>
                <Grid.Column width={15}>
                    <div onClick={() => setIsModalOpen(true)} style={{ cursor: 'pointer' }}>
                        <PreviewMap />
                        <div style={{ marginTop: '8px', fontSize: '14px', color: '#666' }}>
                            {t('gameLocationPreview.clickToViewLarger')}
                        </div>
                    </div>

                    <Modal
                        open={isModalOpen}
                        onClose={() => setIsModalOpen(false)}
                        size='large'
                    >
                        <Modal.Header>
                            {t('gameLocationPreview.gameLocationTitle')}
                            <Button 
                                icon='close' 
                                floated='right' 
                                basic 
                                onClick={() => setIsModalOpen(false)}
                                title={t('gameLocationPreview.closeButton')}
                            />
                        </Modal.Header>
                        <Modal.Content>
                            <FullScreenMap />
                        </Modal.Content>
                    </Modal>
                </Grid.Column>
            </Grid>
        </Segment>
    );
};